import { render, staticRenderFns } from "./CatalogForm.vue?vue&type=template&id=0ca6fa82&"
import script from "./CatalogForm.vue?vue&type=script&lang=ts&"
export * from "./CatalogForm.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/components/forms/zero-waste-form.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports